/**
 * @generated SignedSource<<110e68ea2e9aa7b8dfca2baacc470641>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DevMenuRecordingListDetailsModalQuery$variables = {};
export type DevMenuRecordingListDetailsModalQuery$data = {
  readonly devMenuVideoRecordingsAndClips: ReadonlyArray<{
    readonly createdAt: string;
    readonly dbId: number;
    readonly dueForConversionAt: string | null;
    readonly title: string;
    readonly type: string;
  }>;
};
export type DevMenuRecordingListDetailsModalQuery = {
  response: DevMenuRecordingListDetailsModalQuery$data;
  variables: DevMenuRecordingListDetailsModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DevMenuVideoRecordingOrClip",
    "kind": "LinkedField",
    "name": "devMenuVideoRecordingsAndClips",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dbId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dueForConversionAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DevMenuRecordingListDetailsModalQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DevMenuRecordingListDetailsModalQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "20d94ed8125da1116183bed81c32722d",
    "id": null,
    "metadata": {},
    "name": "DevMenuRecordingListDetailsModalQuery",
    "operationKind": "query",
    "text": "query DevMenuRecordingListDetailsModalQuery {\n  devMenuVideoRecordingsAndClips {\n    dbId\n    createdAt\n    title\n    type\n    dueForConversionAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "75cf9fafe7b68bcdeb25acf01d5f25f3";

export default node;
